import { UserDetailModule } from './../../../user/userDetail/userDetail.module';
import { DialogModule } from 'primeng-lts/dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationComponent } from './navigation.component';
import { OpenedTasksModule } from '../../../tasks/openedTasks/openedTasks.module';
import {
  TranslateModule,
  MissingTranslationHandler
} from '@ngx-translate/core';
import { MyMissingTranslationHandler } from '../../missingtemplate.component';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';

@NgModule({
  declarations: [NavigationComponent],
  imports: [TranslateModule, CommonModule, RouterModule, OpenedTasksModule, ScrollPanelModule, DialogModule],
  exports: [NavigationComponent,
    UserDetailModule],
  providers: [
    {
      provide: MissingTranslationHandler,
      useClass: MyMissingTranslationHandler
    }
  ]
})
export class NavigationModule { }
